export const asset_root_path = "https://static.etableapp.com/icon/";

export default {
  trendIcon: asset_root_path + "trend.png",
  dineintableIcon: asset_root_path + "dineintable.png",
  calendarIcon: asset_root_path + "calendar.png",
  dineinIcon: asset_root_path + "dinein.png",
  languageIcon: asset_root_path + "language.png",
  packageIcon: asset_root_path + "package.png",
  personIcon: asset_root_path + "person.png",
  pickupIcon: asset_root_path + "pickup.png",
  reloadIcon: asset_root_path + "reload.png",
  starIcon: asset_root_path + "star.png",
  supportIcon: asset_root_path + "support.png",
  trendIcon: asset_root_path + "trend.png",
  callwaiter: asset_root_path + "callwaiter.png",
};
